import { Model } from '../parents/model';

export class ShippingMethodModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_PRICE = 'price';

  static ATTR_TAXED_PRICE = 'taxed_price';

  static ATTR_DESCRIPTION = 'description';

  static ATTR_DELIVERY_TIME = 'delivery_time';

  static ATTR_IMAGE_ID = 'image_id';

  static ATTR_TRACKING_URL = 'tracking_url';

  static ATTR_TAX_GROUP_ID = 'tax_group_id';

  static ATTR_IS_ACTIVE = 'is_active';

  static ATTR_OPTIONS_TYPE = 'options_type';

  static ATTR_SHIPPING_SERVICE = 'shipping_service';

  static ATTR_ADDRESS_REQUIREMENT = 'address_requirement';

  static ATTR_HAS_TRACKING_URL = 'has_tracking_url';

  static ATTR_POSITION = 'position';

  static ATTR_IS_FOR_REFUND = 'is_for_refund';

  static EMBED_RULES = 'rules';

  get name() {
    return this.attributes[ShippingMethodModel.ATTR_NAME];
  }

  get price() {
    return this.attributes[ShippingMethodModel.ATTR_PRICE];
  }

  get taxedPrice() {
    return this.attributes[ShippingMethodModel.ATTR_TAXED_PRICE];
  }

  get description() {
    return this.attributes[ShippingMethodModel.ATTR_DESCRIPTION];
  }

  get deliveryTime() {
    return this.attributes[ShippingMethodModel.ATTR_DELIVERY_TIME];
  }

  get imageId() {
    return this.attributes[ShippingMethodModel.ATTR_IMAGE_ID];
  }

  get trackingUrl() {
    return this.attributes[ShippingMethodModel.ATTR_TRACKING_URL];
  }

  get taxGroupId() {
    return this.attributes[ShippingMethodModel.ATTR_TAX_GROUP_ID];
  }

  get isActive() {
    return this.attributes[ShippingMethodModel.ATTR_IS_ACTIVE];
  }

  get optionsType() {
    return this.attributes[ShippingMethodModel.ATTR_OPTIONS_TYPE];
  }

  get shippingService() {
    return this.attributes[ShippingMethodModel.ATTR_SHIPPING_SERVICE];
  }

  get addressRequirement() {
    return this.attributes[ShippingMethodModel.ATTR_ADDRESS_REQUIREMENT];
  }

  get position() {
    return this.attributes[ShippingMethodModel.ATTR_POSITION];
  }

  get hasTrackingUrl() {
    return this.attributes[ShippingMethodModel.ATTR_HAS_TRACKING_URL];
  }

  get isForRefund() {
    return this.attributes[ShippingMethodModel.ATTR_IS_FOR_REFUND];
  }

  get rules() {
    return this.embeds[ShippingMethodModel.EMBED_RULES];
  }
}
